import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { Input } from 'reactstrap';

var IndeterminateCheckbox = function (_a) {
    var indeterminate = _a.indeterminate, props = __rest(_a, ["indeterminate"]);
    var ref = useRef(null);
    useEffect(function () {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && typeof indeterminate === 'boolean') {
            ref.current.indeterminate = !props.checked && indeterminate;
        }
    }, [ref, props.checked, indeterminate]);
    return jsx(Input, __assign({ type: "checkbox", innerRef: ref }, props));
};

export { IndeterminateCheckbox };
